import { createFileRoute } from '@tanstack/react-router'
import { ResellerCdrsPage } from '@/features/reseller/pages/cdrs'

export const Route = createFileRoute('/_authenticated/reseller/cdrs')({
  component: ResellerCdrsPage,
})

